import React, {useContext, useEffect, useReducer, useState} from 'react';
import Timeline from '@mui/lab/Timeline';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {getDiario, setDiario} from "../../../services/AnagraficaServices";
import {initPazienteState, PAZIENTE_INITIAL_STATE, PazienteReducer} from "../../../reducers/PazienteReducer";
import { Alert, AlertTitle, Skeleton, ToggleButton, ToggleButtonGroup } from '@mui/material';

import {
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator,
} from '@mui/lab';

import Typography from "@mui/material/Typography";
import moment from "moment";
import ColorizeTwoToneIcon from "@mui/icons-material/ColorizeTwoTone";
import CallTwoToneIcon from '@mui/icons-material/CallTwoTone';
import TextsmsTwoToneIcon from '@mui/icons-material/TextsmsTwoTone';
import PanToolTwoToneIcon from '@mui/icons-material/PanToolTwoTone';
import ToysTwoToneIcon from '@mui/icons-material/ToysTwoTone';
import LocalPizzaTwoToneIcon from '@mui/icons-material/LocalPizzaTwoTone';
import NoteTwoToneIcon from '@mui/icons-material/NoteTwoTone';
import {
	amber, blue, blueGrey, brown, green, grey, lightBlue,
	lightGreen, orange, pink, purple, red, teal
} from "@mui/material/colors";
import {Avatar, Card, CardActionArea, Chip, Divider, Tooltip} from "@mui/material";
import clsx from "clsx";
import Grid from "@mui/material/Grid";
import {addMinutes, capitalizeFirstLetter, getAccountInfo, isEmpty, isValidDate} from "../../../utils/GenericUtils";
import {useTheme} from "@mui/styles";
import AddTwoToneIcon from "@mui/icons-material/AddTwoTone";
import RemoveTwoToneIcon from "@mui/icons-material/RemoveTwoTone";
import HelpOutlineTwoToneIcon from "@mui/icons-material/HelpOutlineTwoTone";
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import TimelineTwoToneIcon from '@mui/icons-material/TimelineTwoTone';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import ErrorOutlineTwoToneIcon from "@mui/icons-material/ErrorOutlineTwoTone";
import CheckCircleOutlineTwoToneIcon from "@mui/icons-material/CheckCircleOutlineTwoTone";
import RadioButtonUncheckedTwoToneIcon from "@mui/icons-material/RadioButtonUncheckedTwoTone";
import {calcScore, getLastMonitoraggioSintomi} from "../../gestione/focolai/detail/FocolaioCard";
import IntervistaDialog from "./utils/IntervistaDialog";
import {PrenotazioneDialog} from "./utils/PrenotazioneDialog";
import SollecitaTicket from "../../gestione/ticket/storico/SollecitaTicket";
import {AnagraficaContext, TicketContext} from "../../../App";
import {getTicketHistory} from "../../../services/TicketServices";
import {CompilaMonitoraggioDialog} from "./utils/CompilaMonitoraggioDialog";
import {QuarantenaDialog} from "./utils/QuarantenaDialog";
import {calcPunteggioIsolamento} from "../../gestione/quarantene/monitoraggi/form/MonitoraggioIsolamentoGrid";
import {calcPunteggioQuarantenaBoolean} from "../../gestione/quarantene/monitoraggi/form/MonitoraggioQuarantenaGrid";
import {getScoreColor} from "../../gestione/quarantene/detail/QuarantenaCard";
import {useHistory} from "react-router-dom";

const DiarioPaziente = ({ticketSelected, idSoggetto, showPaziente = false, updateDiario = 0}) => {
	const classes = BaseStyle();
	let history = useHistory();
	const [state, dispatch] = useReducer(PazienteReducer, PAZIENTE_INITIAL_STATE, initPazienteState);
	const ticketContext = useContext(TicketContext);
	const anagraficaContext = useContext(AnagraficaContext);
	let theme = useTheme();
	const [openIntervista, setOpenIntervista] = useState("");
	const [openPrenotazione, setOpenPrenotazione] = useState("");
	const [openTicket, setOpenTicket] = useState("");
	const [openQuarantena, setOpenQuarantena] = useState("");
	const [openMonitoraggio, setOpenMonitoraggio] = useState("");
	const [selected, setSelected] = useState({});
	const [formats, setFormats] = React.useState(() => []);

	const handleFormat = (event, newFormats) => {
		setFormats(newFormats);
	};

	const handleCloseTicketDialog = () => {
		setOpenTicket("");
	}

	useEffect(() => {
		if (ticketSelected) {
			getDiario(ticketSelected.idSoggetto, dispatch);
		} else if (idSoggetto && idSoggetto !== "NULL") {
			getDiario(idSoggetto, dispatch);
		}
	}, [ticketSelected, idSoggetto, openPrenotazione, openTicket, openQuarantena, updateDiario, openMonitoraggio, anagraficaContext.dispatch])

	useEffect(() => {
		if (!state.loadingGetDiarioPaziente && state.errorGetDiarioPaziente === "") {
			setDiario(state.diarioPaziente, anagraficaContext.dispatch);
		}
	}, [state.loadingGetDiarioPaziente, state.errorGetDiarioPaziente, anagraficaContext.dispatch, state.diarioPaziente])

	return (
		<React.Fragment>
			<Timeline align="left" className={classes.timeline}>
				<Typography align={"center"} color={"textSecondary"} component={"div"} style={{width: "100%"}}>
					<b>Filtri della Timeline</b>
				</Typography>
				<ToggleButtonGroup value={formats} onChange={handleFormat} style={{
					display: "flex",
					alignContent: "center",
					justifyContent: "center",
					marginBottom: 18,
				}}>
					<ToggleButton value="PrenotazioniTampone">
						<Tooltip title={"Filtra le prenotazioni tampone"}>
							<QuestionAnswerTwoToneIcon/>
						</Tooltip>
					</ToggleButton>

					<ToggleButton value="PrenotazioneTamponeStorico">
						<Tooltip title={"Filtra le note delle prenotazioni tampone"}>
							<NoteTwoToneIcon/>
						</Tooltip>
					</ToggleButton>

					<ToggleButton value="Tamponi">
						<Tooltip title={"Filtra i tamponi"}>
							<ColorizeTwoToneIcon/>
						</Tooltip>
					</ToggleButton>

					<ToggleButton value="Ticket">
						<Tooltip title={"Filtra i ticket"}>
							<CallTwoToneIcon/>
						</Tooltip>
					</ToggleButton>

					<ToggleButton value="Note">
						<Tooltip title={"Filtra le note"}>
							<NoteTwoToneIcon/>
						</Tooltip>
					</ToggleButton>

					<ToggleButton value="Vaccinazioni">
						<Tooltip title={"Filtra le vaccinazioni"}>
							<LocalPizzaTwoToneIcon/>
						</Tooltip>
					</ToggleButton>

					<ToggleButton value="Interviste">
						<Tooltip title={"Filtra le Interviste"}>
							<QuestionAnswerTwoToneIcon/>
						</Tooltip>
					</ToggleButton>

					<ToggleButton value="Monitoraggi">
						<Tooltip title={"Filtra i monitoraggi"}>
							<TimelineTwoToneIcon/>
						</Tooltip>
					</ToggleButton>

					<ToggleButton value="QuaranteneStorico">
						<Tooltip title={"Filtra le note delle ordinanze"}>
							<NoteTwoToneIcon/>
						</Tooltip>
					</ToggleButton>

					<ToggleButton value="Quarantene">
						<Tooltip title={"Filtra le ordinanze (inizio)"}>
							<HomeTwoToneIcon/>
						</Tooltip>
					</ToggleButton>

					<ToggleButton value="Fine">
						<Tooltip title={"Filtra le ordinanze (fine)"}>
							<HomeTwoToneIcon/>
						</Tooltip>
					</ToggleButton>
				</ToggleButtonGroup>
				{showPaziente && <Typography align={"center"} component={"div"}>
					Paziente:
					<b>{
						!isEmpty(anagraficaContext.state.anagrafica) ?
							<React.Fragment>
								{(capitalizeFirstLetter(anagraficaContext.state.anagrafica.nome) + " " + capitalizeFirstLetter(anagraficaContext.state.anagrafica.cognome))}<br/>
								{(anagraficaContext.state.anagrafica.codF)}
							</React.Fragment> : "--"
					}</b>
					<Divider/>
				</Typography>}
				{
					idSoggetto !== "NULL" && (state.loadingGetDiarioPaziente) ? <Skeleton/> :
						state.errorGetDiarioPaziente !== "" ? <Alert severity="error" style={{borderRadius: 24}}>
							<AlertTitle>Errore</AlertTitle>
							Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
							sviluppatori.
						</Alert> : <React.Fragment>
							{
								sortDiarioPaziente(state.diarioPaziente).length === 0 ?
									<Alert severity="info" style={{borderRadius: 24}}>
										<AlertTitle><b>Niente diario</b></AlertTitle>
										Questo paziente non ha ancora nulla nel suo diario
									</Alert> :
									sortDiarioPaziente(state.diarioPaziente)
										.filter(diaryItem => formats.length === 0 ? diaryItem : formats.includes(diaryItem.object.type))
										.map((item, index) => {
											switch (item.object.type) {
												default:
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{
																	width: "100%",
																}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b><br/>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot style={{backgroundColor: grey[800], boxShadow: "none"}}>
																	<PanToolTwoToneIcon/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}>
																	<CardActionArea
																		style={{width: "100%", height: "100%", padding: 12}}>
																		<Grid container spacing={1}>
																			<Grid item xs={12}>
																				<Typography variant="subtitle1">
																					<b> ... lavori in corso ...</b>
																				</Typography>
																				<Typography variant="subtitle1">
																					<b> {item.object.type} </b>
																				</Typography>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "Oggi":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}/>
															<TimelineSeparator>
																<TimelineDot style={{backgroundColor: grey[50]}}>
																	<ToysTwoToneIcon style={{color: "#000"}}/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: theme.palette.mode === "light" ? grey[50] : grey[900]
																      }}>
																	<CardActionArea
																		style={{width: "100%", height: "100%", padding: 12}}>
																		<Grid container spacing={1}>
																			<Grid item xs={12}>
																				<Typography variant="subtitle1" color={"primary"} align={"center"}>
																					<b>Oggi</b>
																				</Typography>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "Protocolli":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{paddingTop: 10, color: teal[600]}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot style={{backgroundColor: teal[400], boxShadow: "none"}}>
																	<QuestionAnswerTwoToneIcon/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}>
																	<CardActionArea
																		style={{width: "100%", height: "100%", padding: 12}}>
																		<Grid container spacing={1}>
																			<Grid item xs={12}>
																				<Typography variant="subtitle1">
																					<b>Protocollo</b>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Typography variant="subtitle2" color={"textSecondary"}>
																					Tipo: {item.object.value.tipo}<br/>
																					Numero: {item.object.value.numeroProtocollo}
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Chip label={item.object.value.stato}
																				      variant={"outlined"} style={{margin: 2, backgroundColor: blue[200]}}/>
																				<Chip
																					label={
																						<span style={{wordWrap: "break-word", whiteSpace: "pre-wrap"}}>
																					{(item.object?.value?.active ? "In gestione ora da parte di " : ("Ultima modifica " + moment(new Date(item.object.value.dataUltimaModifica)).format("DD/MM/YYYY HH:mm") + " di ")) + item.object.value.lastModify}
																					</span>
																					}
																					variant={"outlined"}
																					style={{
																						margin: 2,
																						backgroundColor: (item.object?.value?.active ? amber["A700"] : blueGrey[900]),
																						color: "#FFF",
																						height: "auto"
																					}}/>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "PrenotazioniTampone":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{paddingTop: 10, color: blue[600]}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot style={{backgroundColor: blue[400], boxShadow: "none"}}>
																	<QuestionAnswerTwoToneIcon/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}
																>
																	<CardActionArea
																		style={{width: "100%", height: "100%", padding: 12}}
																		onClick={() => {
																			setSelected(item.object.value);
																			setOpenPrenotazione(item.object.value?.id);
																		}}>
																		<Grid container spacing={1}>
																			<Grid item xs={12}>
																				<Typography variant="subtitle1">
																					<b>Richiesta prenotazione
																						tampone</b> {item.object.value.criterioEpidemiologico && <span
																					style={{color: blue[400]}}>{item.object.value.criterioEpidemiologico === "TC" ? " di controllo" : item.object.value.criterioEpidemiologico === "TD" ? " di diagnosi" : ""}</span>}
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Typography variant="subtitle2" color={"textSecondary"}>
																					Luogo: <b>{item.object.value.luogo}</b><br/>
																					Data effettiva:
																					<b>{item.object.value.dataEffettiva ?
																						(moment(item.object.value.dataEffettiva).format("DD/MM/YYYY") + (" in fascia " + (item.object.value.nfascia + 8) + ":00 - " + (item.object.value.nfascia + 9) + ":00"))
																						: "--"}
																					</b>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Chip label={item.object.value.stato}
																				      variant={"outlined"} style={{margin: 2, backgroundColor: blue[200]}}/>
																				{
																					item.object.value?.motivazione && item.object.value.motivazione.includes("Prioritaria") &&
																					<Chip label={"Prioritaria"} variant={"outlined"}
																					      style={{margin: 2, backgroundColor: amber[500]}}/>
																				}
																				<Chip
																					label={
																						<span style={{wordWrap: "break-word", whiteSpace: "pre-wrap"}}>
																					{(item.object?.value?.active ? "In gestione ora da parte di " : ("Ultima modifica " + moment(new Date(item.object.value.dataUltimaModifica)).format("DD/MM/YYYY HH:mm") + " di ")) + item.object.value.lastModify}
																					</span>
																					}
																					variant={"outlined"}
																					style={{
																						margin: 2,
																						backgroundColor: (item.object?.value?.active ? amber["A700"] : blueGrey[900]),
																						color: "#FFF",
																						height: "auto"
																					}}/>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "Interviste":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{paddingTop: 10, color: brown[600]}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot style={{backgroundColor: brown[400], boxShadow: "none"}}>
																	<QuestionAnswerTwoToneIcon/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}>
																	<CardActionArea
																		onClick={() => setOpenIntervista(item.object.value.id)}
																		style={{width: "100%", height: "100%", padding: 12}}>
																		<Grid container spacing={1}>
																			<Grid item xs={12}>
																				<Typography variant="subtitle1">
																					<b>Intervista</b>
																				</Typography>
																			</Grid>
																			{
																				item.object.value?.dataComparsaSintomi &&
																				<Grid item xs={12}>
																					<Typography variant={"subtitle2"} color={"textSecondary"}>
																						Sintomi comparsi
																						da {moment(item.object.value?.dataComparsaSintomi).format("DD/MM/YYYY")}
																					</Typography>
																				</Grid>
																			}
																			<Grid item xs={12}>
																				{
																					item.object.value?.listaSintomi?.length > 0 && item.object.value?.listaSintomi?.split(",")?.map(tag => {
																						return (
																							<Chip
																								key={tag}
																								label={tag}
																								avatar={<Avatar
																									style={{backgroundColor: red[700], color: "#FFF"}}><b>#</b></Avatar>}
																								color={"default"}
																								style={{
																									marginRight: 8,
																									marginTop: 8,
																									color: "#FFF",
																									backgroundColor: red[400]
																								}}/>
																						)
																					})
																				}

																				{
																					item.object.value?.listaPatologieCroniche?.length > 0 && item.object.value?.listaPatologieCroniche?.split(",")?.map(tag => {
																						return (
																							<Chip
																								key={tag}
																								label={tag}
																								avatar={<Avatar
																									style={{backgroundColor: green[700], color: "#FFF"}}><b>#</b></Avatar>}
																								color={"default"}
																								style={{
																									marginRight: 8,
																									marginTop: 8,
																									color: "#FFF",
																									backgroundColor: green[400]
																								}}/>
																						)
																					})
																				}

																				{
																					item.object.value?.listaImmunodepressioni?.length > 0 && item.object.value?.listaImmunodepressioni?.split(",")?.map(tag => {
																						return (
																							<Chip
																								key={tag}
																								label={tag}
																								avatar={<Avatar
																									style={{backgroundColor: amber[700], color: "#FFF"}}><b>#</b></Avatar>}
																								color={"default"}
																								style={{
																									marginRight: 8,
																									marginTop: 8,
																									color: "#000",
																									backgroundColor: amber[400]
																								}}/>
																						)
																					})
																				}

																				{
																					item.object.value?.listaEspRischio?.length > 0 && item.object.value?.listaEspRischio?.split(",")?.map(tag => {
																						return (
																							<Chip
																								key={tag}
																								label={tag}
																								avatar={<Avatar
																									style={{backgroundColor: purple[700], color: "#FFF"}}><b>#</b></Avatar>}
																								color={"default"}
																								style={{
																									marginRight: 8,
																									marginTop: 8,
																									color: "#FFF",
																									backgroundColor: purple[400]
																								}}/>
																						)
																					})
																				}
																			</Grid>
																			<Grid item xs={12}>
																				<Chip
																					label={
																						<span style={{wordWrap: "break-word", whiteSpace: "pre-wrap"}}>
																					{(item.object?.value?.active ? "In gestione ora da parte di " : ("Ultima modifica " + moment(new Date(item.object.value.dataInserimento)).format("DD/MM/YYYY HH:mm") + " di ")) + item.object.value.lastModify}
																					</span>
																					}
																					variant={"outlined"}
																					style={{
																						margin: 2,
																						backgroundColor: (item.object?.value?.active ? amber["A700"] : blueGrey[900]),
																						color: "#FFF",
																						height: "auto"
																					}}/>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "Monitoraggi":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{paddingTop: 10, color: orange[600]}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot style={{backgroundColor: orange[400], boxShadow: "none"}}>
																	<TimelineTwoToneIcon/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}>
																	<CardActionArea
																		onClick={() => {
																			setOpenMonitoraggio(item.object.value)
																		}}
																		style={{width: "100%", height: "100%", padding: 12}}>
																		<Grid container spacing={1}>
																			<Grid item xs={12} style={{display: "flex"}}>
																				<Typography variant="subtitle1" style={{flexGrow: 1}}>
																					<b>Monitoraggio</b>
																				</Typography>
																				<Chip
																					icon={calcScore([item.object.value], item.object.value["drm"] ? "Isolamento" : "Quarantena") >= 3 ?
																						<ErrorOutlineTwoToneIcon style={{color: "#FFF"}}/> :
																						calcScore([item.object.value], item.object.value["drm"] ? "Isolamento" : "Quarantena") <= 1 ?
																							<CheckCircleOutlineTwoToneIcon
																								style={{color: calcScore([item.object.value], (item.object.value["drm"] !== undefined ? "Isolamento" : "Quarantena"), (item.object.value["drm"] !== undefined ? calcPunteggioIsolamento(item.object.value) : (calcPunteggioQuarantenaBoolean(item.object.value) * 4 / 12))) === 1 ? "#000" : "#FFF",}}/> :
																							<RadioButtonUncheckedTwoToneIcon style={{color: "#FFF"}}/>}
																					label={"SCORE " + (item.object.value["drm"] !== undefined ? calcPunteggioIsolamento(item.object.value) : (calcPunteggioQuarantenaBoolean(item.object.value) * 4 / 12))}
																					/*label={"SCORE " + calcScore([item.object.value], item.object.value["drm"] ? "Isolamento" : "Quarantena")}*/
																					style={{
																						marginRight: 10,
																						marginLeft: 10,
																						padding: 4,
																						fontWeight: "bold",
																						color: calcScore([item.object.value], (item.object.value["drm"] !== undefined ? "Isolamento" : "Quarantena"), (item.object.value["drm"] !== undefined ? calcPunteggioIsolamento(item.object.value) : (calcPunteggioQuarantenaBoolean(item.object.value) * 4 / 12))) === 1 ? "#000" : "#FFF",
																						backgroundColor: getScoreColor((item.object.value["drm"] !== undefined ? "Isolamento" : "Quarantena"), [item.object.value]),
																						/*	backgroundColor: (item.object.value["drm"] !== undefined ? calcPunteggioIsolamento(item.object.value) : (calcPunteggioQuarantenaBoolean(item.object.value) * 4 / 12)) === 0 ? green[600] :
																						 (item.object.value["drm"] !== undefined ? calcPunteggioIsolamento(item.object.value) : (calcPunteggioQuarantenaBoolean(item.object.value) * 4 / 12)) === 1 ? amber[600] :
																						 (item.object.value["drm"] !== undefined ? calcPunteggioIsolamento(item.object.value) : (calcPunteggioQuarantenaBoolean(item.object.value) * 4 / 12)) === 2 ? orange[600] :
																						 (item.object.value["drm"] !== undefined ? calcPunteggioIsolamento(item.object.value) : (calcPunteggioQuarantenaBoolean(item.object.value) * 4 / 12)) === 3 ? red[600] :
																						 purple[500]*/
																					}}/>
																			</Grid>
																			<Grid item xs={12}>
																				<Typography variant="subtitle2" color={"textSecondary"}>
																					<b>{item.object.value.compilatoUtente ? "Compilato dal'utente" : "Compilato tramite callcenter"}</b>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				{/*<div style={{overflowX: "scroll"}}>
																					<MonitoraggiIsolamentoTable monitoraggi={[item.object.value]}/>
																				</div>*/}
																				<div>
																					{
																						getLastMonitoraggioSintomi([item.object.value]).map(sintomo => {
																							return (
																								<Chip
																									key={sintomo}
																									label={capitalizeFirstLetter(sintomo)}
																									avatar={<Avatar><b>#</b></Avatar>}
																									color={"secondary"}
																									style={{
																										marginRight: 8,
																										marginTop: 8,
																									}}/>
																							)
																						})
																					}
																					{
																						item.object.value?.febbre &&
																						<Chip label={'Febbre: ' + item.object.value.febbre} color={"primary"}
																						      avatar={<Avatar><b>F</b></Avatar>}
																						      style={{
																							      marginRight: 8,
																							      marginTop: 8,
																						      }}/>
																					}
																					{
																						item.object.value?.saturazioneO2 &&
																						<Chip label={'Saturazione: ' + item.object.value.saturazioneO2} color={"primary"}
																						      avatar={<Avatar><b>S</b></Avatar>}
																						      style={{
																							      marginRight: 8,
																							      marginTop: 8,
																						      }}/>
																					}
																				</div>
																				<Chip
																					label={
																						<span style={{wordWrap: "break-word", whiteSpace: "pre-wrap"}}>
																					{item.object.value.lastModify}
																					</span>
																					}
																					variant={"outlined"}
																					style={{
																						margin: 2,
																						backgroundColor: blueGrey[900],
																						color: "#FFF",
																						height: "auto"
																					}}/>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "Quarantene":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{paddingTop: 10, color: purple[600]}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot style={{backgroundColor: purple[400], boxShadow: "none"}}>
																	<HomeTwoToneIcon/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}>
																	<CardActionArea
																		onClick={() => setOpenQuarantena(item.object.value?.id)}
																		style={{width: "100%", height: "100%", padding: 12}}>
																		<Grid container spacing={1}>
																			<Grid item xs={12}>
																				<Typography variant="subtitle1">
																					<b>Inizio {item.object.value?.tipo}</b>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Typography variant="subtitle2" color={"textSecondary"}>
																					<b>Monitoraggio {item.object.value.tipoMonitoraggio}</b>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Tooltip title={item.object.value.note ? item.object.value.note : "--"}>
																					<Typography variant="body2" color={"textSecondary"}>
																						{item.object.value?.note === "" && " non sono presenti note"}
																						{item.object.value.note?.substring(0, 84) + (item.object.value.note?.length > 80 ? "..." : "")}
																					</Typography>
																				</Tooltip>
																			</Grid>
																			<Grid item xs={12}>
																				<Chip label={item.object.value.stato}
																				      variant={"outlined"} style={{margin: 2, backgroundColor: purple[200]}}/>
																				<Chip
																					label={
																						<span style={{wordWrap: "break-word", whiteSpace: "pre-wrap"}}>
																					{(item.object?.value?.active ? "In gestione ora da parte di " : ("Ultima modifica " + moment(new Date(item.object.value.ultimaModifica)).format("DD/MM/YYYY HH:mm") + " di ")) + item.object.value.lastModify}
																					</span>
																					}
																					variant={"outlined"}
																					style={{
																						margin: 2,
																						backgroundColor: (item.object?.value?.active ? amber["A700"] : blueGrey[900]),
																						color: "#FFF",
																						height: "auto"
																					}}/>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "Note":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{
																	paddingTop: 10,
																	color: item?.object?.value?.text === "PAZIENTE NON ESENTABILE" ? red[900] : teal[400]
																}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot style={{
																	backgroundColor: item?.object?.value?.text === "PAZIENTE NON ESENTABILE" ? red[900] : teal[400],
																	boxShadow: "none"
																}}>
																	{
																		item?.object?.value?.text === "PAZIENTE NON ESENTABILE" ?
																			<PanToolTwoToneIcon/> :
																			<NoteTwoToneIcon/>
																	}
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																{
																	item?.object?.value?.text === "PAZIENTE NON ESENTABILE" ?
																		<Card className={clsx(classes.roundBorder)}
																		      style={{
																			      width: "100%",
																			      backgroundColor: red[500],
																			      color: "#FFF"
																		      }}>
																			<CardActionArea
																				style={{width: "100%", height: "100%", padding: 12}}>
																				<Grid container spacing={1}>
																					<Grid item xs={12}>
																						<Typography variant={"body2"} align={"center"}>
																							Dichiarato
																						</Typography>
																						<Typography variant={"subtitle1"} align={"center"}>
																							<b>NON ESENTABILE</b>
																						</Typography>
																						<Typography variant={"body2"} align={"center"}>
																							da {item.object.value?.lastModify}
																						</Typography>
																					</Grid>
																				</Grid>
																			</CardActionArea>
																		</Card> :
																		<Card className={clsx(classes.roundBorder)}
																		      style={{
																			      width: "100%",
																			      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																		      }}>
																			<CardActionArea
																				style={{width: "100%", height: "100%", padding: 12}}>
																				<Grid container spacing={1}>
																					<Grid item xs={12}>
																						<Typography variant="subtitle1">
																							<b>Note inserite da: {item.object.value?.lastModify}</b>
																						</Typography>
																					</Grid>
																					<Grid item xs={12}>
																						<Typography color={"textSecondary"}>
																							{item.object.value?.text}
																						</Typography>
																					</Grid>
																				</Grid>
																			</CardActionArea>
																		</Card>
																}

															</TimelineContent>
														</TimelineItem>
													)
												case "QuaranteneStorico":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{paddingTop: 10, color: pink[600]}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot style={{backgroundColor: pink[400], boxShadow: "none"}}>
																	<NoteTwoToneIcon/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}>
																	<CardActionArea
																		style={{width: "100%", height: "100%", padding: 12}}>
																		<Grid container spacing={1}>
																			<Grid item xs={12}>
																				<Typography variant="subtitle1">
																					<b>Note ordinanza</b>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Typography color={"textSecondary"} style={{
																					overflowWrap: "anywhere"
																				}} component={"div"}>
																					{
																						item.object.value?.note?.startsWith("{\" ") ?
																							parseQuarantena(item.object.value?.note) :
																							item.object.value?.note
																					}
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Chip
																					label={
																						<span style={{wordWrap: "break-word", whiteSpace: "pre-wrap"}}>
																					{(item.object?.value?.active ? "In gestione ora da parte di " : ("Ultima modifica di ")) + item.object.value.lastModify}
																					</span>}
																					variant={"outlined"}
																					style={{
																						height: "auto",
																						margin: 2,
																						backgroundColor: (item.object?.value?.active ? amber["A700"] : blueGrey[900]),
																						color: "#FFF",
																						wordWrap: "break-word",
																						maxWidth: 520,
																					}}/>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "PrenotazioneTamponeStorico":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{paddingTop: 10, color: lightBlue[600]}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot style={{backgroundColor: lightBlue[400], boxShadow: "none"}}>
																	<NoteTwoToneIcon/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}>
																	<CardActionArea
																		style={{width: "100%", height: "100%", padding: 12}}>
																		<Grid container spacing={1}>
																			<Grid item xs={12}>
																				<Typography variant="subtitle1">
																					<b>Note prenotazione</b>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Typography color={"textSecondary"} style={{
																					overflowWrap: "anywhere"
																				}} component={"div"}>
																					{
																						item.object.value?.note?.startsWith("{\" ") ?
																							parseQuarantena(item.object.value?.note) :
																							item.object.value?.note
																					}
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Chip
																					label={
																						<span style={{wordWrap: "break-word", whiteSpace: "pre-wrap"}}>
																					{(item.object?.value?.active ? "In gestione ora da parte di " : ("Ultima modifica di ")) + item.object.value.lastModify}
																					</span>}
																					variant={"outlined"}
																					style={{
																						height: "auto",
																						margin: 2,
																						backgroundColor: (item.object?.value?.active ? amber["A700"] : blueGrey[900]),
																						color: "#FFF",
																						wordWrap: "break-word",
																						maxWidth: 520,
																					}}/>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "Fine":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{paddingTop: 10, color: purple[600]}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot style={{backgroundColor: purple[400], boxShadow: "none"}}>
																	<HomeTwoToneIcon/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}>
																	<CardActionArea
																		onClick={() => setOpenQuarantena(item.object?.id)}
																		style={{width: "100%", height: "100%", padding: 12}}>
																		<Grid container spacing={1}>
																			<Grid item xs={12}>
																				<Typography variant="subtitle1">
																					<b>Fine {item.object?.tipo}</b>
																				</Typography>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "Tamponi":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{paddingTop: 10, color: red[600]}}>
																	{
																		item.object.value.esitoTampone === "N/D" ? "In attesa di esito..." :
																			<React.Fragment>
																				{moment(item.data).format("DD/MM/YYYY")}<br/>
																				<b>{moment(item.data).format("HH:mm")}</b><br/>
																			</React.Fragment>
																	}
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot style={{backgroundColor: red[400], boxShadow: "none"}}>
																	<ColorizeTwoToneIcon/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}>
																	<CardActionArea
																		style={{width: "100%", height: "100%", padding: 12}}
																		disabled={getAccountInfo().roles?.includes('ROLE_SP_301_H')}
																		onClick={() => history.push("/gestione/interviste/" + item.object.value.id)}>
																		<Grid container spacing={1}>
																			<Grid item xs={12}>
																				<Typography variant="subtitle1">
																					<b>Tampone effettuato</b>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Typography variant="body2" color={"textSecondary"}>
																					Tipo tampone: {item.object.value.testTipoDesc}
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Typography variant="subtitle2" color={"textSecondary"}>
																					<b>{item.object.value.laboratorio + " - " + item.object.value.esitoTampone}</b>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Typography variant="body2" color={"textSecondary"}>
																					{item.object.value.criterioEpidemiologico}
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Typography variant={"body2"} color={"textSecondary"}>
																					Data Esito: {moment(item.object.value.dataEsito).format("DD/MM/YYYY")}<br/>
																					Data
																					PrelievoEffettiva: {moment(item.object.value.dataPrelievoEffettiva).format("DD/MM/YYYY")}<br/>
																					Data
																					PrelievoPrevista: {moment(item.object.value.dataPrelievoPrevista).format("DD/MM/YYYY")}<br/>
																					Data
																					Richiesta: {moment(item.object.value.dataRichiesta).format("DD/MM/YYYY")}<br/>
																					Data
																					Risoluzione: {moment(item.object.value.dataRisoluzione).format("DD/MM/YYYY")}<br/>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Chip label={item.object.value.stato} variant={"outlined"} style={{
																					margin: 2,
																					backgroundColor: item.object.value.stato === "Non gestito" ? red[200] : item.object.value.stato === "Gestito" ? green[200] : amber[200]
																				}}/>
																				{
																					item.object.value.active &&
																					<Chip label={
																						<span style={{wordWrap: "break-word", whiteSpace: "pre-wrap"}}>
																						In gestione da parte di {item.object.value.lastModify}
																					</span>
																					}
																					      variant={"outlined"}
																					      style={{margin: 2, backgroundColor: blue[200], height: "auto"}}/>
																				}
																				{
																					item.object.value.esitoTampone === "POSITIVO" &&
																					<Chip label={"POSITIVO"} variant={"outlined"}
																					      avatar={<Avatar style={{backgroundColor: red[700]}}><AddTwoToneIcon
																						      style={{color: "#000", fontSize: 20}}/></Avatar>} style={{
																						margin: 2,
																						backgroundColor: red[200],
																						color: "#000"
																					}}/>
																				}
																				{
																					item.object.value.esitoTampone === "NEGATIVO" &&
																					<Chip label={"NEGATIVO"} variant={"outlined"}
																					      avatar={<Avatar style={{backgroundColor: green[500]}}><RemoveTwoToneIcon
																						      style={{color: "#000", fontSize: 20}}/></Avatar>} style={{
																						margin: 2,
																						backgroundColor: green[200],
																						color: "#000"
																					}}/>
																				}
																				{
																					item.object.value.esitoTampone !== "NEGATIVO" && item.object.value.esitoTampone !== "POSITIVO" &&
																					<Chip
																						label={item.object.value.esitoTampone === "N/D" ? "NON DICHIARATO" : item.object.value.esitoTampone}
																						variant={"outlined"}
																						avatar={<Avatar
																							style={{backgroundColor: orange[500]}}><HelpOutlineTwoToneIcon
																							style={{color: "#000", fontSize: 20}}/></Avatar>} style={{
																						margin: 2,
																						backgroundColor: orange[200],
																						color: "#000"
																					}}/>
																				}
																				<Chip
																					label={
																						<span style={{wordWrap: "break-word", whiteSpace: "pre-wrap"}}>
																					{(item.object?.value?.active ? "In gestione ora da parte di " : ("Ultima modifica " + moment(new Date(item.object.value.dataUltimaModifica)).format("DD/MM/YYYY HH:mm") + " di ")) + item.object.value.lastModify}
																					</span>
																					}
																					variant={"outlined"}
																					style={{
																						margin: 2,
																						backgroundColor: (item.object?.value?.active ? amber["A700"] : blueGrey[900]),
																						color: "#FFF",
																						height: "auto"
																					}}/>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "Ticket":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{paddingTop: 10, color: green[600]}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b><br/>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot
																	style={{
																		backgroundColor: item.object.value.type === "CCM" ? lightGreen[500] : green[600],
																		boxShadow: "none"
																	}}>
																	{
																		item.object.value.type === "CCM" ?
																			<CallTwoToneIcon/> :
																			<TextsmsTwoToneIcon/>
																	}
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}>
																	<CardActionArea
																		style={{width: "100%", height: "100%", padding: 12}}
																		onClick={() => {
																			getTicketHistory(item.object.value, ticketContext.dispatch);
																			setSelected(item.object.value);
																			setOpenTicket(item.object.value?.id)
																		}}>
																		<Grid container spacing={1}>
																			<Grid item xs={12}>
																				<Typography variant="subtitle1">
																					<b>{item.object.value.type === "CCM" ? "Ticket Callcenter" : "Ticket Form"}</b>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Typography variant="subtitle2" color={"textSecondary"} noWrap={true} style={{
																					wordWrap: "break-word",
																					maxWidth: 520,
																				}}>
																					<b>{item.object.value.categoria + " - " + item.object.value.sottoCategoria}</b>
																				</Typography>
																			</Grid>
																			<Grid item xs={12}>
																				<Tooltip title={item.object.value.dettaglioRichiesta}>
																					<Typography variant="body2" color={"textSecondary"}>
																						{item.object.value.dettaglioRichiesta.substring(0, 84) + (item.object.value.dettaglioRichiesta.length > 80 ? "..." : "")}
																					</Typography>
																				</Tooltip>
																			</Grid>
																			<Grid item xs={12}>
																				<Chip label={item.object.value.stato} variant={"outlined"} style={{
																					margin: 2,
																					backgroundColor: item.object.value.stato === "Aperto" ? red[200] : item.object.value.stato === "Risolto" ? green[200] : amber[200]
																				}}/>
																				<Chip
																					label={
																						<span style={{wordWrap: "break-word"}}>
																					{(item.object?.value?.active ? "In gestione ora da parte di " : ("Ultima modifica " + moment(new Date(item.object.value.dataUltimaModifica)).format("DD/MM/YYYY HH:mm") + " di ")) + item.object.value.lastModify}
																					</span>}
																					variant={"outlined"}
																					style={{
																						height: "auto",
																						margin: 2,
																						backgroundColor: (item.object?.value?.active ? amber["A700"] : blueGrey[900]),
																						color: "#FFF",
																						wordWrap: "break-word",
																						maxWidth: 520,
																					}}/>
																			</Grid>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
												case "Vaccinazioni":
													return (
														<TimelineItem key={index} style={{minHeight: "auto"}}>
															<TimelineOppositeContent style={{maxWidth: 120}}>
																<Typography variant="body2" style={{paddingTop: 10, color: blue[600]}}>
																	{moment(item.data).format("DD/MM/YYYY")}<br/>
																	<b>{moment(item.data).format("HH:mm")}</b><br/>
																</Typography>
															</TimelineOppositeContent>
															<TimelineSeparator>
																<TimelineDot
																	style={{
																		backgroundColor: blue[600],
																		boxShadow: "none"
																	}}>
																	<LocalPizzaTwoToneIcon/>
																</TimelineDot>
																<TimelineConnector/>
															</TimelineSeparator>
															<TimelineContent style={{flexGrow: 1}}>
																<Card className={clsx(classes.roundBorder)}
																      style={{
																	      width: "100%",
																	      backgroundColor: item.isQuarantena ? theme.palette.mode === "light" ? amber[100] : amber[800] : theme.palette.mode === "light" ? "#FFF" : "#212121"
																      }}>
																	<CardActionArea
																		style={{width: "100%", height: "100%", padding: 12}}>
																		<Grid container spacing={1}>
																			<Typography variant="subtitle1">
																				<b>{
																					moment(new Date(item.data)).format("DD/MM/YYYY") === moment(item.object.value.dataPrimaDose).format("DD/MM/YYYY") ? "Vaccino - Prima dose" :
																						moment(new Date(item.data)).format("DD/MM/YYYY") === moment(item.object.value.dataSecondaDose).format("DD/MM/YYYY") ? "Vaccino - Seconda dose" :
																							moment(new Date(item.data)).format("DD/MM/YYYY") === moment(item.object.value.dataTerzaDose).format("DD/MM/YYYY") ? "Vaccino - Terza dose" :
																								"Vaccino - Quarta dose"}</b>
																			</Typography>
																		</Grid>
																		<Grid item xs={12}>
																			<Typography variant={"body2"} color={"textSecondary"}>
																				Tipo
																				vaccino: {
																				moment(new Date(item.data)).format("DD/MM/YYYY") === moment(item.object.value.dataPrimaDose).format("DD/MM/YYYY") ?
																					item.object.value.tipoVaccinoPrimaDose : moment(new Date(item.data)).format("DD/MM/YYYY") === moment(item.object.value.dataSecondaDose).format("DD/MM/YYYY") ?
																						item.object.value.tipoVaccinoSecondaDose : item.object.value.tipoVaccinoTerzaDose}
																			</Typography>
																		</Grid>
																	</CardActionArea>
																</Card>
															</TimelineContent>
														</TimelineItem>
													)
											}
										})
							}
						</React.Fragment>
				}

			</Timeline>

			{
				openIntervista !== "" &&
				<IntervistaDialog idIntervista={openIntervista} setIntervista={setOpenIntervista}/>
			}

			{
				openPrenotazione !== "" &&
				<PrenotazioneDialog idPrenotazione={openPrenotazione} setPrenotazione={setOpenPrenotazione} selected={selected}
				                    setSelected={setSelected}/>}
			{
				openTicket !== "" &&
				<SollecitaTicket open={openTicket !== ""} onClose={handleCloseTicketDialog} ticket={selected} isDiary={true}/>
			}

			{
				openMonitoraggio !== "" &&
				<CompilaMonitoraggioDialog monitoraggio={openMonitoraggio} setOpen={setOpenMonitoraggio}/>
			}

			{
				openQuarantena !== "" &&
				<QuarantenaDialog idQuarantena={openQuarantena} setOpen={setOpenQuarantena}/>
			}
		</React.Fragment>
	);
};

function sortDiarioPaziente(diario) {
	/**
	 * Creo un dizionario con chiavi le date e valori gli oggetti (ticket o tamponi o chi per esso...)
	 * Può esistere un duplicato per data? Ni, nel senso che a livello teorico sì ma a livello pratico no perché il
	 * paziente fisicamente non può fare due cose per volta (chiama callcenter e fa vaccino per esempio)
	 */
	let firstStep = {};
	Object.keys(diario).forEach(key => {
		Object.keys(diario[key]).forEach(innerKey => {
			if (firstStep[innerKey] !== null && key === "Interviste") {
				firstStep = {
					...firstStep,
					[addMinutes(new Date(innerKey), 2)]: {
						type: key,
						value: diario[key][innerKey]
					}
				}
			} else {
				firstStep = {
					...firstStep,
					[innerKey]: {
						type: key,
						value: diario[key][innerKey]
					}
				}
			}
		})
	})

	/**
	 * Ora arriva il bello, fare un ordinamento di tutto sto casino e mettere tutto in un array :)
	 */
	let secondStep = [];
	Object.entries(firstStep).forEach(([key, val]) => {

		if (Array.isArray(val.value)) {

			val.value.forEach(valItem => {
				secondStep.push({
					data: new Date(key),
					object: {
						type: val.type,
						value: valItem
					},
				})
			})

		} else {

			secondStep.push({
				data: new Date(key),
				object: val,
			})

		}
	});

	/**
	 * Aggiungo oggi
	 */
	secondStep.push({
		data: new Date(),
		object: {
			type: "Oggi",
			tipo: "Oggi",
		}
	})
	let fineQuarantene = [];
	secondStep.forEach(item => {
		if (item.object.type === "Quarantene") {
			fineQuarantene.push({
				data: new Date(item.object.value.dataFine),
				object: {
					...item.object.value,
					type: "Fine",
					tipo: item.object.value.tipo,
					isQuarantena: true,
				},
			})
		}
		if (!isValidDate(item.data)) {
			if (item.object.type === "Tamponi") {
				item.data = new Date();
				item.esitoTampone = "In attesa di esito"
			}
		}
	})


	/**
	 * Aggiungo la fine quarantena al diario e ordino il tutto
	 */
	let thirdStep = [...secondStep, ...fineQuarantene];
	thirdStep = thirdStep.sort(function (a, b) {
		return new Date(b.data) - new Date(a.data);
	});

	/**
	 * Parte tre: settare un booleano per definire se l'item fa parte di una quarantena
	 */
	let isQuarantena = false;
	thirdStep.forEach(item => {
		item.isQuarantena = isQuarantena;
		if (item.object.type === "Quarantene") {
			isQuarantena = false;
		}
		if (item.object.type === "Fine") {
			item.isQuarantena = true;
			isQuarantena = true;
		}
	})

	return thirdStep;
}

function parseQuarantena(note) {
	let result;
	try {
		let quarantena = JSON.parse(note);
		//console.log(quarantena);
		result = <React.Fragment>
			Quarantena prima delle modifiche:
			<ul>
				<li>Data inizo: {moment(new Date(quarantena[" dataInizio"])).format("DD/MM/YYYY")}</li>
				<li>Data fine: {moment(new Date(quarantena[" dataFine"])).format("DD/MM/YYYY")}</li>
				<li>Tipo: {quarantena[" tipo"]}</li>
				<li>Tipo monitoraggio: {quarantena[" tipoMonitoraggio"]}</li>
				<li>Score: {quarantena[" score"]}</li>
			</ul>
		</React.Fragment>
	} catch (e) {
		console.log(e)
		return <React.Fragment>Errore nel parsing delle note...</React.Fragment>
	}
	return result
}

export default React.memo(DiarioPaziente)
